import UiUxPageSection from "../components/pagesSections/UiUxPageSection";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Section from "../components/Section";
import { PinContainer } from "../components/ui/3d-pin.tsx";
import { media, BaseURL } from "../server.js";
import axios from "axios";
import Heading from "../components/Heading.jsx";
import { useTranslation } from "react-i18next";
import { useStateContext } from "../context/ContextProvider.js";
import Loader from "../components/Loader.jsx";
function UiUxPage() {
  const { id } = useParams();
  const { currentDir } = useStateContext();
  const [project, setProject] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const { t } = useTranslation();
  useEffect(() => {
    const getProject = async () => {
      try {
        const { data } = await axios.get(`${BaseURL}/project/${id}`);
        setProject(data.project);
        setIsLoading(false);
        console.log("Fetched project:", data.project);
      } catch (error) {
        console.log(error.response?.data?.message || "Error fetching project");
        setIsLoading(false);
      }
    };
    getProject();
  }, [id]); // Added `id` to the dependency array

  

  return (
    <Section>
      {isLoading ? (
        <Loader />
      ) : (
        <div className="container flex-1 ">
          <Heading
            title={currentDir == "ltr" ? project?.titleEn : project?.titleAr}
            text={currentDir == "ltr" ? project?.textEn : project?.textAr}
          />

            <UiUxPageSection cards={project} />

        </div>
      )}
    </Section>
  );
}

export default UiUxPage;
